import type { TaxAmount } from 'types/shopping-cart';

export const ZERO_CART_TAX_AMOUNT: TaxAmount = {
  amount: 0,
  currency: { currency_code: '', formatted_amount: '' },
};

function isTaxAmountShape(value: unknown): value is TaxAmount {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  if (typeof v.amount !== 'number' || Number.isNaN(v.amount)) return false;
  const c = v.currency;
  if (!c || typeof c !== 'object') return false;
  const cur = c as Record<string, unknown>;
  return typeof cur.currency_code === 'string' && typeof cur.formatted_amount === 'string';
}

/**
 * Scheduled charge sync may send tax as a JSON string, an object, or a legacy numeric total.
 * Never throws; falls back to zero tax for malformed values.
 */
export function parseCartTaxAmountFromScheduledCharge(raw: unknown): TaxAmount {
  if (raw === null || raw === undefined) return ZERO_CART_TAX_AMOUNT;
  if (typeof raw === 'number') {
    return Number.isFinite(raw)
      ? {
          amount: raw,
          currency: { currency_code: '', formatted_amount: '' },
        }
      : ZERO_CART_TAX_AMOUNT;
  }
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed === '') return ZERO_CART_TAX_AMOUNT;
    try {
      const parsed: unknown = JSON.parse(trimmed);
      return isTaxAmountShape(parsed) ? parsed : ZERO_CART_TAX_AMOUNT;
    } catch {
      return ZERO_CART_TAX_AMOUNT;
    }
  }
  if (isTaxAmountShape(raw)) return raw;
  return ZERO_CART_TAX_AMOUNT;
}
